module.exports = function(service) {
	'use strict'
	service.factory('escapeElastic', escapeElastic);
	escapeElastic.$inject = [];
	function escapeElastic() {
	   	return function(content) {
			content = content.replace(/\//g, " ");
          	content = content.replace(/\+/g, "\\\+");
          	content = content.replace(/\=/g, "\\\=");
          	content = content.replace(/\-/g, "\\\-");
          	content = content.replace(/\|\|/g, "\\\|\\\|");
          	content = content.replace(/\>/g, "\\\>");
          	content = content.replace(/\</g, "\\\<");
          	content = content.replace(/\!/g, "\\\!");
          	content = content.replace(/\(/g, "\\\(");
          	content = content.replace(/\)/g, "\\\)");
          	content = content.replace(/\{/g, "\\\{");
          	content = content.replace(/\}/g, "\\\}");
          	content = content.replace(/\[/g, "\\\[");
          	content = content.replace(/\]/g, "\\\]");
          	content = content.replace(/\?/g, "\\\?");
          	content = content.replace(/\"/g, "\\\"");
          	content = content.replace(/\*/g, "\\\*");
          	content = content.replace(/\~/g, "\\\~");
          	content = content.replace(/\&\&/g, "\\\&\\\&");
          	content = content.replace(/\^/g, "\\\^");
	        return content;
	   }
	}
}



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/escapeElasticService.js
// module id = 601
// module chunks = 0